import { TableBody as MuiTableBody, TableBodyProps } from '@mui/material';

const TableBody = (props: TableBodyProps) => {
  return <MuiTableBody {...props} />;
};

export default TableBody;
